module.exports = __webpack_public_path__ + "cz.072878bc.svg";